import ComponentBase from '../base/component-base';
import ScrollLock from '../../libs/scroll-lock';

/**
 * Global Menu Component (SP)
 * ハンバーガー(.js-global-menu-trigger)で開閉するSPのグローバルメニュー
 */
class GlobalMenu extends ComponentBase {
  private triggers: HTMLButtonElement[] = [];
  private header: HTMLElement | null = null;
  private isOpen: boolean = false;
  private lastFocused: HTMLElement | null = null;
  private onTriggerClickBinding: (e: Event) => void;
  private onKeydownBinding: (e: KeyboardEvent) => void;

  constructor(element: HTMLElement) {
    super(element);

    this.onTriggerClickBinding = this.onTriggerClick.bind(this);
    this.onKeydownBinding = this.onKeydown.bind(this);

    this.init();
  }

  protected init(): void {
    this.triggers = Array.from(document.querySelectorAll<HTMLButtonElement>('.js-global-menu-trigger'));
    this.header = document.querySelector('.js-global-header');

    if (this.triggers.length === 0) {
      console.warn('[GlobalMenu] trigger not found');
      return;
    }

    this.triggers.forEach((t) => t.addEventListener('click', this.onTriggerClickBinding));
    document.addEventListener('keydown', this.onKeydownBinding);
  }

  private onTriggerClick(e: Event): void {
    e.preventDefault();
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  private onKeydown(e: KeyboardEvent): void {
    if (this.isOpen && e.key === 'Escape') {
      this.close();
    }
  }

  private open(): void {
    this.lastFocused = document.activeElement as HTMLElement;
    this.element.removeAttribute('hidden');
    // hidden解除直後だとtransitionが走らないため次フレームでクラスを付ける
    requestAnimationFrame(() => this.element.classList.add('is-open'));
    this.header?.classList.add('is-menu-open');
    this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));
    ScrollLock.getInstance().disable();
    this.isOpen = true;

    const firstLink = this.element.querySelector<HTMLElement>('.c-global-menu__link');
    firstLink?.focus();
  }

  private close(): void {
    this.element.classList.remove('is-open');
    this.header?.classList.remove('is-menu-open');
    this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    ScrollLock.getInstance().enable();
    this.isOpen = false;

    window.setTimeout(() => {
      if (!this.isOpen) {
        this.element.setAttribute('hidden', '');
      }
    }, 300);

    this.lastFocused?.focus();
  }

  protected onDestroy(): void {
    super.onDestroy();

    this.triggers.forEach((t) => t.removeEventListener('click', this.onTriggerClickBinding));
    document.removeEventListener('keydown', this.onKeydownBinding);
  }
}

export default GlobalMenu;
